export default __webpack_public_path__ + "static/media/AgentWebiste3.7c86b857.png";